import styled from "styled-components";

export const Middle = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.colors.elements};
  border-radius: 15px;
  align-self: center;
  margin: 50px 0;
`;

interface IconWrapperProps {
  firstTwo?: boolean;
}

export const IconsContainer = styled.div`
  display: flex;
  gap: 4rem;
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;
export const IconWrapper = styled.div<IconWrapperProps>`
  width: 100px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  @media (max-width: 768px) {
    width: auto;
  }
  .bola {
    cursor: pointer;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) =>
      props.firstTwo
        ? props.theme.colors.primary
        : props.theme.colors.elements};
    border-radius: 50%;
    @media (max-width: 768px) {
      width: 48px;
      height: 48px;
    }

    svg {
      width: 24px;
      fill: ${(props) =>
        props.firstTwo ? "white" : props.theme.colors.placeholder};
    }
  }

  .texto {
    text-align: center;
    margin-top: 10px;
    color: ${(props) => props.theme.colors.tertiary};
  }
`;

interface ContainerCompartilharProps {
  isGrid?: boolean;
}

export const ContainerCompartilhar = styled.div<ContainerCompartilharProps>`
  padding: 10rem 10rem 10rem 10rem;
  display: ${(props) => (props.isGrid ? 'grid' : 'block')};
  grid-template-columns: ${(props) => (props.isGrid ? '50% 50%' : 'none')};

  .conteudo {
    .topo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: ${(props) => props.theme.colors.white};
      border-radius: 15px;
      padding: 3rem 5rem;
      svg {
        margin-top: -8rem;
      }

      .texto {
        font-family: 'Inter';
        text-align: right;
        color: ${(props) => props.theme.colors.primary};
        font-weight: bold;
      }
    }
    .catalogos {
      .titulo {
        text-align: left;
        color: ${(props) => props.theme.colors.secondary};
        font-weight: bold;
        margin: 5rem 0 2rem;
      }
    }
    .compartilhar {
      .titulo {
        text-align: left;
        padding: 3rem 1rem;
        font-weight: bold;
        color: ${(props) => props.theme.colors.tertiary};
        @media (max-width: 1024px) {
          text-align: center;
          padding: 2rem 0;
        }
      }
    }
    .baixo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: ${(props) => props.theme.colors.white};
      border-radius: 15px;
      margin-top: 10rem;
      padding: 2rem 5rem;

      svg {
        margin-top: -8rem;
      }

      .texto {
        font-family: 'Inter';
        text-align: left;
        color: ${(props) => props.theme.colors.primary};
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        gap: 1rem;
        @media (max-width: 1024px) {
          align-items: center;
        }
        
        .titulo-container {
          display: flex;
          align-items: flex-end;
          justify-content: start;
          gap: 10px; 
          @media (max-width: 1024px) {
            justify-content: center;
          }

          &.bloqueado{
            color: ${(props) => props.theme.colors.disable};
          }

          .icone-bloqueado {
            svg{
              margin-top: -4rem;
            }
          }
        }
        
        span {
          font-weight: normal;

          &.bloqueado{
            color: ${(props) => props.theme.colors.disable};
          }
        }
        .configuracoes {
          display: flex;
          justify-content: flex-start;
          margin-top: 30px;
          align-items: center;
          .botao {
            cursor: pointer;
            font-weight: normal;
            color: ${(props) => props.theme.colors.tertiary};
            background-color: ${(props) => props.theme.colors.elements};
            padding: 1rem 10rem;
            border-radius: 18px;
            text-decoration: none;
          }
        }
      }
    }
  }

  .conteudo,
  .lado-direito {
    min-width: 0;
  }

  .lado-direito {
    margin-left: 5rem;
    padding-left: 5rem;
    border-left: 2px solid ${(props) => props.theme.colors.elements};
  }

  .url{
    text-align: left;
    color: white;
    margin-top: 15px;
    a{
      color: ${(props) => props.theme.colors.primary};
    }
  }
  @media (max-width: 1024px) {
    padding: 5rem 5rem 10rem 5rem;
    grid-template-columns: 100%;

    .lado-direito {
      margin: 10rem 0 0;
      padding: 10rem 0 0;
      border-left: none;
      border-top: 2px solid ${(props) => props.theme.colors.elements};
    }
  }
  @media (max-width: 535px) {
    .conteudo {
      .baixo {
        flex-wrap: wrap;
        padding: 4rem 4rem;
        gap: 6rem;
        .texto {
          flex-grow: 1;
          text-align: center;
          .configuracoes {
            justify-content: center;
            margin-top: 1rem;
          }
        }
        svg {
          margin-top: 0rem;
          flex-grow: 1;
        }
      }
    }
  }
`;
